import { render, staticRenderFns } from "./FreestyleContentTab.vue?vue&type=template&id=d9e742be&scoped=true&"
import script from "./FreestyleContentTab.vue?vue&type=script&lang=js&"
export * from "./FreestyleContentTab.vue?vue&type=script&lang=js&"
import style0 from "./FreestyleContentTab.vue?vue&type=style&index=0&id=d9e742be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9e742be",
  null
  
)

export default component.exports